import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  projectDescription: {
    fontSize: '18px',
    paddingLeft: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    borderRadius: '10px',
    resize: 'vertical',
    width: '100%',
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    '&:focus': {
      outline: 'none',
      borderColor: '#d8dde1',
      backgroundColor: '#fff',
    },
    '&:hover': {
      border: '1px solid #d8dde1',
    },
  },
}));
